export const DISTRICT = "DISTRICT";
export const AREA = "AREA";
export const LOCATION = "LOCATION";
export const TALUKA = "TALUKA";
export const LOADING = "LOADING"
